import { render, staticRenderFns } from "./counselor.vue?vue&type=template&id=4e10ccb8&scoped=true&"
import script from "./counselor.vue?vue&type=script&lang=js&"
export * from "./counselor.vue?vue&type=script&lang=js&"
import style0 from "./counselor.vue?vue&type=style&index=0&id=4e10ccb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e10ccb8",
  null
  
)

export default component.exports